
import { mapActions, mapGetters, mapState } from 'vuex';
import Typing from '../common/Typing.vue';

export default {
  components: { Typing },
  props: {
    stackIndex: { type: Number, default: null },
    embedUrl: { type: String, default: '' },
    title: { type: String, default: '' },
    id: { type: String, default: '' },
  },

  data() {
    return {
      iframeLoading: true,
    };
  },

  computed: {
    ...mapState('embeddedStore', ['isOpened', 'embedCompleted']),
    ...mapGetters('chatbotStore', ['lastStackNode', 'isPreview']),
    ...mapState('chatbotStore', ['currentConversation']),

    embedSrc() {
      return decodeURI(this.embedUrl).replace(/\{\{URL_DOMAIN\}\}/, encodeURIComponent(window.location.host));
    },

    iframeEl() {
      return this.$refs.iframe?.$el?.getElementsByTagName('iframe')[0];
    },
  },

  mounted() {
    if (this.lastStackNode.node.id === this.id) {
      this.setIsOpened(true);
    }
  },

  destroyed() {
    this.iframeEl?.removeEventListener('load', this.onIframeLoad);
  },

  methods: {
    ...mapActions('embeddedStore', ['setIsOpened']),

    goBack() {
      this.setIsOpened(false);

      this.$tracking?.sendResponseEvent('embedded', {
        embeddedId: this.id,
        stateType: 'CLOSE',
        statusType: 'FALSE',
        conversationId: this.currentConversation.id,
      });
    },

    /**
     * The "load" event of the vue-friendly-iframe component is emitted long before the
     * content of the iframe is emitted. It is emitted just as the iframe is setup to actually
     * render the correct iframe URL. Therefore we setup an event listener for the "load"
     * event on the iframe element itself.
     * @see https://github.com/officert/vue-friendly-iframe/issues/42#issuecomment-1029412066
     */
    onFriendlyIframeLoad() {
      if (this.iframeEl) {
        this.iframeEl.addEventListener('load', this.onIframeLoad);
      } else {
        this.onIframeLoad();
      }
    },

    onIframeLoad() {
      this.iframeLoading = false;
    },
  },
};
